/**
 * achievements.ts — award milestones. Each grants a permanent global multiplier
 * (applied automatically via computeMultipliers).
 */
import type { GameState } from '../core/GameState';
import type { EventBus } from '../core/EventBus';
import { ACHIEVEMENTS } from '../data';
import { meetsRequirement } from './unlock';

export function checkAchievements(state: GameState, bus?: EventBus): void {
  for (const a of ACHIEVEMENTS) {
    if (state.achievements[a.id]) continue;
    if (meetsRequirement(state, a.requires)) {
      state.achievements[a.id] = true;
      bus?.emit('achievement:earned', { achievementId: a.id });
      bus?.emit('notify', { kind: 'success', message: `🏆 Erfolg: ${a.name}` });
    }
  }
}

export function earnedCount(state: GameState): number {
  return ACHIEVEMENTS.reduce((n, a) => n + (state.achievements[a.id] ? 1 : 0), 0);
}
